export class Availability {
    always: boolean;
    now: boolean;
    description: string | null;
    startdate: string | null;
    enddate: string | null;
    isdisabled: boolean;
}
